import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
        <div className='eye'>
            <div className='pull'>
                <br />
                <br />
                <h1 className='abm'>About me</h1>
                <div className='fle'>
            <div className='line'></div>
                </div>
                <div className='aboui'>
                    <div data-aos="fade-right"
                        data-aos-duration="2000"
                        id='nam2'>
                        <h2>Name: Nwanze Johnmary</h2>
                        <h2>Date of Birth: 28 of March, 1996</h2>
                        <h2>Address: Mushin, Lagos State</h2>
                        <h2>Zip-code:101283</h2>
                        <h2>Email:nwanzejohnmary01@gmail.com</h2>
                        <h2>Phone:(+234) 903 228 9003</h2>
                    </div>
                    <div data-aos="fade-left"
                        data-aos-duration="2000"
                        id='nam'>
                        <p>I'm a Front-End Developer located in Surulere currently on a intennship with a Africa leading FinTech firm. I have a in depth love fir UI effects, animations, creating intuitive dynamic user experience.</p>
                        <p>Well organized person, problem solver due to my empathy, a team-work with high attention to details.</p>
                        <p>Interested in the entire Front-End spectrum and working on larger codeBase projects with positive people.</p>
                    </div>
            </div>
        </div>
    </div>
    )
  }
}
        //   <h3>Name:</h3><span>Nwanze Johnmary Ngozi</span>
        //   <h3>Location:</h3><span>Lagos State</span>
        //   <h3>Degree:</h3><span>Bsc</span>
        //   <h3>Phone:</h3><span>+234 903 228 9003</span>
        //   <span>johnmarynwanze@yahoo.com</span>
        //   <span>nwanzejohnmary01@gmail.com</span>
    //   <Footer/>
